import { t } from '@sm/intl';

const COPY = {
  allbirds: {
    id: 'mrx.getLocalizedLogos.allbirds',
    defaultMessage: 'Allbirds company logo',
    description: '[Type: Label][Vis: low] - Labels Allbirds logo'
  },
  ibm: {
    id: 'mrx.getLocalizedLogos.ibm',
    defaultMessage: 'IBM company logo',
    description: '[Type: Label][Vis: low] - Labels IBM company logo'
  },
  just: {
    id: 'mrx.getLocalizedLogos.just',
    defaultMessage: 'JUST company logo',
    description: '[Type: Label][Vis: low] - Labels JUST company logo'
  },
  rj: {
    id: 'mrx.getLocalizedLogos.rj',
    defaultMessage: 'Raymond James company logo',
    description: '[Type: Label][Vis: low] - Labels Raymond James company logo'
  },
  tweezerman: {
    id: 'mrx.getLocalizedLogos.tweezerman',
    defaultMessage: 'Tweezerman company logo',
    description: '[Type: Label][Vis: low] - Labels Tweezerman company logo'
  }
};

const getLocalizedLogos = async (locale = 'en_US') => {
  if (locale === 'en_US') {
    return [
      {
        id: 'ibmLogo',
        name: t(COPY.ibm),
        image: (await import('./ibm_logo.png')).default
      },
      {
        id: 'tweezermanLogo',
        name: t(COPY.tweezerman),
        image: (await import('./tweezerman_logo.png')).default
      },

      {
        id: 'justLogo',
        name: t(COPY.just),
        image: (await import('./just_logo.png')).default
      },
      {
        id: 'raymondJamesLogo',
        name: t(COPY.rj),
        image: (await import('./rj_logo.png')).default
      },
      {
        id: 'allbirdsLogo',
        name: t(COPY.allbirds),
        image: (await import('./allbirds_logo.png')).default
      }
    ];
  }
  return [];
};

export default getLocalizedLogos;
